// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"497":"fd5b71ac","543":"c08f61ca","658":"dc4e241f","956":"39975332"}[chunkId] + ".chunk.js";
};